import script from "./AppUrl.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUrl.vue?vue&type=script&setup=true&lang=js"

export default script